export const APP_LABEL = 'Neuralert';

export const MENU_WIDTH = '15rem';

export const ROOT = process.env.BASE_API_URL;
export const WEBSOCKET_ADDRESS = process.env.BASE_WS_URL;
export const LOGIN_URL = 'api-token-auth/';
export const REFRESH_TOKEN_URL = 'api-token-refresh/';
export const UNLINK_ALL = 'unlink-all/';
export const DEVICES_URL = 'devices/';
export const PATIENTS_URL = 'patients/';
export const USERS_URL = 'users/';
export const INVITE_URL = 'invite/';
export const RESET_PASSWORD_LINK_URL = 'reset-link/';
export const RESET_PASSWORD_URL = 'reset/';
export const SET_NEW_PIN = 'new-pin/';
export const HISTORY_URL = 'devicelogs/';
export const HISTORY_ALERTS_URL = 'alert-response/';
export const HISTORY_PAUSES_URL = 'devicepause/';
export const HISTORY_LOW_BATTERY_URL = 'low-battery/';
export const SENT_NOTIFICATIONS_URL = 'sent-notifications/'
export const EXPORT_ALARMS_URL = 'alert-response-csv/';
export const EXPORT_LOGS_URL = 'devicelog-csv/';
export const EXPORT_META_URL = 'device-meta-csv/';
export const MESSAGES_URL = 'mqttmessages/';
export const PROFILE_URL = 'current_user/';
export const PASSWORD_URL = 'password_change/';
export const MOBILE_DEVICES_URL = 'mobiledevices/';
export const GROUPS_URL = 'groups/';
export const PAUSE_URL = 'pause/';
export const OFF_PAUSE_URL = 'offpause/';
export const PAUSE_STATE_URL = 'devicepause/';
export const META_DATA_URL = 'device-meta/';

export const ADMIN_URL = 'users/';
export const UNLINK_URL = 'unlink/';
export const LINK_URL = 'link/';

export const LOGOUT_URL = process.env.SSO_LOGOUT_URL;

export const SET_DEVICES = 'SET_DEVICES';
export const ADD_DEVICES = 'ADD_DEVICES';
export const SET_NEXT_DEVICE_PAGE = 'SET_NEXT_DEVICE_PAGE';
export const SET_CURRENT_DEVICE = 'SET_CURRENT_DEVICE';
export const SET_DEVICE_COUNT = 'SET_DEVICE_COUNT';
export const SET_PATIENTS = 'SET_PATIENTS';
export const SET_CURRENT_PATIENT = 'SET_CURRENT_PATIENT';
export const SET_PATIENT_DEVICES = 'SET_PATIENT_DEVICES';
export const SET_PATIENT_COUNT = 'SET_PATIENT_COUNT';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_HISTORY_COUNT = 'SET_HISTORY_COUNT';
export const SET_HISTORY_RECORDS = 'SET_HISTORY_RECORDS';
export const SET_HISTORY_RECORDS_COUNT = 'SET_HISTORY_RECORDS_COUNT';
export const SET_HISTORY_RECORDS_PATIENT = 'SET_HISTORY_RECORDS_PATIENT';
export const SET_NOTIFICATIONS_RECORDS = 'SET_NOTIFICATIONS_RECORDS';
export const SET_NOTIFICATIONS_RECORDS_COUNT = 'SET_NOTIFICATIONS_RECORDS_COUNT';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_LAST_ACTIVE = 'SET_LAST_ACTIVE';
export const SET_LAST_REFRESHED = 'SET_LAST_REFRESHED';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ERROR = 'SET_ERROR';
export const SET_IS_REFRESHING = 'SET_IS_REFRESHING';
export const SET_USERS = 'SET_USERS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_MOBILE_DEVICES = 'SET_MOBILE_DEVICES';
export const SET_GROUPS = 'SET_GROUPS';
export const SET_LAST_CLICKED = 'SET_LAST_CLICKED';
export const SET_CURRENT_PATIENT_PAUSE_STATE = 'SET_CURRENT_PATIENT_PAUSE_STATE';
export const SET_META_DATA = 'SET_META_DATA';

export const LAST_ACTIVE_THRESHOLD = 1200000; // twenty minutes
export const LAST_CLICK_THRESHOLD = 600000; // ten minutes
export const COUNTDOWN_TIMER = 480000; // eight minutes
